<template>
    <div v-if="showMenu">
        <div @click="showDropdown = false" v-if="showDropdown" class="dropdown-backdrop"></div>

        <div class="right-menu relative flex items-center">
            <div v-if="isSchoolRoles" class="hidden xl:block font-size-16 system-primary-text-color">
                <i class="fas fa-user-graduate"></i>
                <span class="ml-2">
                    {{ schoolRole }} | {{ schoolName }}
                    <span
                        v-if="schoolLength > 1"
                        v-tippy="{
                            placement: 'bottom',
                            content: $t('school_switch_account')
                        }"
                        @click="toggleShowSchoolModal"
                        class="cursor-pointer"
                    >
                        |
                        <i class="fas fa-retweet"></i>
                    </span>
                </span>
            </div>
            <a
                v-if="!hideButton"
                @click.prevent="onDropdownToggleHandler"
                href="javascript:void(0)"
                style="text-decoration: none"
            >
                <i
                    :class="{
                        'theme-ui-text-color theme-question-shadow fas bar-icon': true,
                        'fa-bars': !isLoggedIn() || !loginStatus
                    }"
                    v-if="!isLoggedIn() && !loginStatus"
                ></i>
                <ProfileImage v-else />
            </a>

            <div :class="{ 'menu-dropdown': true, show: showDropdown }">
                <ul class="" v-if="isLoggedIn()">
                    <li>
                        <flag-lang @close="changeLanguage"></flag-lang>
                    </li>
                    <li class="more-space">
                        <div class="flex items-start user-info-block">
                            <div class="block">
                                <i class="fas fa-user-circle text-xl user-icon"></i>
                            </div>
                            <div style="flex: 1">
                                <span class="block username-text mb-2" style="line-height: 1.2">
                                    {{ name }}
                                </span>
                                <span class="block text-base credit-text">{{
                                    translate('top_right_menu_credit', {
                                        credit: creditFromState || credit,
                                        s: creditFromState > 1 || credit > 1 ? 's' : ''
                                    })
                                }}</span>
                                <span v-if="showPremium()" id="text-premium" :class="stylePremium()">
                                    {{ textPremium }}
                                </span>
                                <span v-else-if="getIsSchoolRoles()" :class="styleSchoolRole()" id="school-role">
                                    {{ textSchoolRole }}
                                    <span
                                        :title="$t('playlive_limit_player', { limitPlayer: limitPlayer })"
                                        class="cursor-pointer"
                                        >({{ limitPlayer }} <i class="icon-user fas fa-user"></i>)
                                    </span>
                                </span>
                            </div>
                            <a @click.prevent="logout" class="logout-link" href="">
                                <i class="fas fa-sign-out-alt"></i>
                                <span>{{ translate('top_right_menu_logout') }}</span>
                            </a>
                        </div>
                        <div
                            v-if="schoolRole"
                            id="school-box"
                            class="w-full mt-3 flex xl:hidden items-center justify-between text-xs"
                        >
                            <div class="flex flex-col overflow-hidden">
                                <span class="mr-2 font-bold">{{ $t('school_info_logged_as') }} {{ schoolRole }}</span>
                                <!-- <span>{{ schoolClass }}</span> -->
                                <div v-if="schoolName || schoolDistrict" :title="schoolAndDistrict" class="flex mt-1">
                                    <span v-if="schoolName" class="mr-1 truncate">
                                        {{ schoolName }}{{ schoolDistrict ? ',' : '' }}
                                    </span>
                                    <span v-if="schoolDistrict" class="truncate">
                                        {{ schoolDistrict }}
                                    </span>
                                </div>
                            </div>
                            <div
                                v-if="schoolLength > 1"
                                @click="toggleShowSchoolModal"
                                class="flex items-center cursor-pointer py-2"
                            >
                                <i class="fas fa-retweet" style="margin-right: 0px"></i>
                                <span class="font-bold">{{ $t('school_switch_account') }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-if="!isLoggedIn()">
                    <li>
                        <flag-lang @close="changeLanguage"></flag-lang>
                    </li>
                    <li>
                        <a
                            :title="translate('top_right_menu_login')"
                            @click.prevent="handleOpenModal"
                            href="javascript:void(0)"
                            class="text-link"
                        >
                            <i class="fas fa-sign-in-alt" style="margin-right: 10px"></i>
                            <span>{{ translate('top_right_menu_login') }}</span>
                        </a>
                    </li>
                </ul>
                <div class="divider" v-if="subMenu.length > 0"></div>
                <div>
                    <ul class="" v-if="isLoggedIn()">
                        <li v-if="isPageIntro()">
                            <a :title="translate('show_introduce') + '.'" @click.prevent="onClearIntroLocal" href="#">
                                <i class="fas fa-question-circle"></i>
                                <span>{{ translate('show_introduce') }}</span>
                            </a>
                        </li>
                        <li v-if="!getIsStudentRoles()">
                            <a :title="translate('top_right_menu_new') + '.'" @click.prevent="clickNewQuiz" href="#">
                                <i class="fas fa-plus"></i>
                                <span>{{ translate('top_right_menu_new') }}</span>
                            </a>
                        </li>
                        <li v-if="!getIsStudentRoles()">
                            <a
                                :title="translate('top_right_menu_quiz_poll') + '.'"
                                @click.prevent="clickYourQuiz"
                                class="text-link"
                                href=""
                            >
                                <i class="far fa-check-circle"></i>
                                <span>{{ translate('top_right_menu_quiz_poll') }}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                :title="translate('top_right_menu_edit_profile') + '.'"
                                @click.prevent="clickEditProfile"
                                class="text-link"
                                href="#"
                            >
                                <i class="far fa-edit"></i>
                                <span>{{ translate('top_right_menu_edit_profile') }}</span>
                            </a>
                        </li>
                        <li v-if="userRole() !== 'student_plus' && userRole() !== 'student'">
                            <a
                                :title="translate('top_right_menu_orders') + '.'"
                                @click.prevent="clickOrder"
                                class="text-link"
                                href="#"
                            >
                                <i class="fas fa-list-alt"></i>
                                <span>{{ translate('top_right_menu_orders') }}</span>
                            </a>
                        </li>
                        <li v-if="userRole() !== 'student_plus' && userRole() !== 'student'">
                            <a
                                :title="translate('top_right_menu_purchase') + '.'"
                                @click.prevent="clickSubscribePlan"
                                class="text-link"
                                href="#"
                            >
                                <i class="fas fa-dollar-sign"></i>
                                <span>{{ translate('top_right_menu_purchase') }}</span>
                            </a>
                        </li>
                        <li v-if="!getIsStudentRoles()">
                            <a
                                :title="translate('top_right_menu_subscribe') + '.'"
                                @click.prevent="handleOpenNewsletter"
                                class="text-link"
                                href="#"
                            >
                                <i class="fas fa-bell"></i>
                                <span>{{ translate('top_right_menu_subscribe') }}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                :title="translate('top_right_menu_school') + '.'"
                                :href="redirectSchool"
                                class="text-link"
                            >
                                <i class="fas fa-school"></i>
                                <span>{{ translate('top_right_menu_school') }}</span>
                            </a>
                        </li>
                    </ul>
                    <ul v-if="!isLoggedIn()">
                        <li>
                            <a :title="translate('top_right_menu_create') + '.'" @click.prevent="clickNewQuiz" href="#">
                                <i class="fas fa-plus"></i>
                                <span>{{ translate('top_right_menu_create') }}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                :title="translate('top_right_menu_purchase') + '.'"
                                @click.prevent="clickSubscribePlan"
                                class="text-link"
                                href="#"
                            >
                                <i class="fas fa-dollar-sign"></i>
                                <span>{{ translate('top_right_menu_purchase') }}</span>
                            </a>
                        </li>
                        <li v-if="!getIsStudentRoles()">
                            <a
                                :title="translate('top_right_menu_subscribe') + '.'"
                                @click.prevent="handleOpenNewsletter"
                                class="text-link"
                                href="#"
                            >
                                <i class="fas fa-bell"></i>
                                <span>{{ translate('top_right_menu_subscribe') }}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                :title="translate('top_right_menu_school') + '.'"
                                :href="redirectSchool"
                                class="text-link"
                            >
                                <i class="fas fa-school"></i>
                                <span>{{ translate('top_right_menu_school') }}</span>
                            </a>
                        </li>
                    </ul>
                    <div class="divider" v-if="subMenu.length > 0"></div>
                    <ul v-if="subMenu.length > 0" class="sub-menu-box">
                        <li v-for="(item, index) in subMenu" :key="index">
                            <template v-if="item.is_slide">
                                <a
                                    @click.prevent="togglePageSlidePopup(item.slug)"
                                    :title="item.title + '.'"
                                    class="text-link"
                                    href="#"
                                >
                                    <i :class="item.class_icon"></i>
                                    <span>{{ item.title }}</span>
                                </a>
                            </template>
                            <template v-else>
                                <a :title="item.title + '.'" :href="`/article/${item.slug}`" class="text-link">
                                    <i :class="item.class_icon"></i>
                                    <span>{{ item.title }}</span>
                                </a>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <SwitchSchoolModal v-if="showSwitchSchoolModal" @close="showSwitchSchoolModal = false" ref="switchSchool" />
    </div>
</template>

<script>
import UserService from '@/lib/user'
import ProfileImage from '@/components/ProfileImage'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import FlagLang from '@/components/FlagLang.vue'
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
import helperMixins from '@/mixins/helper.js'
import { startIntroMasterStart, setSetting } from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'
import { currentUser } from '@/lib/user'
import SwitchSchoolModal from '@/components/SwitchSchoolModal'
import { nuxtUrl } from '@/lib/nuxt-url.js'

export default {
    name: 'TopRightMenu',

    components: {
        ProfileImage,
        FlagLang,
        SwitchSchoolModal
    },

    mixins: [helperMixins, introJsData],

    data() {
        return {
            showDropdown: false,
            tokenValid: false,
            name: '',
            credit: 0,
            orderAbility: {},
            schoolClass: null,
            schoolName: null,
            schoolDistrict: null,
            schoolLength: null,
            showSwitchSchoolModal: false,
            limitPlayer: 0,
            subMenu: []
        }
    },

    computed: {
        creditFromState() {
            return this.$store ? this.$store.state.credit : false
        },

        ...mapState({
            showTopRightMenu: state => state.showTopRightMenu,
            subPageMenu: state => state.subPageMenu,
            geoLocation: state => state.geoLocation
        }),

        showMenu() {
            if (!this.$store) {
                //from php
                return Cookies.get('lang') && typeof Cookies.get('lang') != 'undefined' ? true : false
            }

            return this.showTopRightMenu // from store
        },

        textPremium() {
            if (this.isBackendUser()) {
                return this.translate(`role_${this.userRole()}`)
            }

            if (this.orderAbility.has_subscribed) {
                return this.translate('top_right_menu_premium_access')
            }

            if (this.orderAbility.is_24hrs_access) {
                return this.translate('top_right_menu_24_hr_premium_access')
            }

            return ''
        },

        schoolRole() {
            if (this.userRole() === 'teacher') {
                return this.translate('school_role_teacher')
            }

            if (this.userRole() === 'student') {
                return this.translate('school_role_student')
            }

            if (this.userRole() === 'teacher_plus') {
                return this.translate('school_role_teacher_plus')
            }

            if (this.userRole() === 'student_plus') {
                return this.translate('school_role_student_plus')
            }

            return ''
        },

        textSchoolRole() {
            if (this.userRole() === 'teacher') {
                return this.translate('school_role_teacher_basic')
            }

            if (this.userRole() === 'student') {
                return this.translate('school_role_student_basic')
            }

            if (this.userRole() === 'teacher_plus') {
                return this.translate('school_role_teacher_plus')
            }

            if (this.userRole() === 'student_plus') {
                return this.translate('school_role_student_plus')
            }

            return ''
        },

        schoolAndDistrict() {
            return [this.schoolName, this.schoolDistrict].filter(Boolean).join(', ')
        },

        isPlayTogether() {
            return this.$route.query.type == 'pt'
        },

        nuxtPath() {
            return process.env.VUE_APP_NUXT_BASE_URL
        },

        feide() {
            return currentUser() && currentUser().provider === 'feide' ? true : false
        },

        isNorway() {
            return this.geoLocation && this.geoLocation.code === 'NO'
        },

        redirectSchool() {
            if (!this.isLoggedIn() && this.isNorway) {
                return nuxtUrl('/skoler')
            }

            if (this.feide) {
                return nuxtUrl('/skoler')
            }

            return nuxtUrl('/school')
        }
    },

    props: {
        loginStatus: {
            type: Boolean,
            default: false
        },
        getCreditTrigger: {
            type: Number,
            default: 0
        },
        hideButton: {
            type: Boolean,
            default: false
        },
        embed: {
            type: String,
            default: null
        }
    },

    watch: {
        getCreditTrigger: function () {
            this.getCredit()
        }
    },

    created() {
        if (this.getIsSchoolRoles()) {
            this.schoolClass = currentUser().school_class
            this.schoolName = currentUser().school_name
            this.schoolDistrict = currentUser().school_district
            this.schoolLength = currentUser().schools.length
        }
    },

    mounted() {
        this.validateToken()

        this.$nextTick(() => {
            const userService = new UserService()
            this.name = userService.getUser()['name']
        })

        window.addEventListener('login-success', () => {
            const userService = new UserService()
            this.name = userService.getUser()['name']
            this.findOrderAbility()

            if (this.getIsSchoolRoles()) {
                this.schoolClass = currentUser().school_class
                this.schoolName = currentUser().school_name
                this.schoolDistrict = currentUser().school_district
                this.schoolLength = currentUser().schools.length
                this.getLimitPlayer()
            }
        })

        window.addEventListener('feide-login-success', () => {
            this.schoolClass = currentUser().school_class
            this.schoolName = currentUser().school_name
            this.schoolDistrict = currentUser().school_district
            this.schoolLength = currentUser().schools.length
            this.getLimitPlayer()
        })

        window.addEventListener('page-open', e => {
            var detail = e.detail
            this.togglePageSlidePopup(detail.slug)
        })

        this.getSubPageMenu()

        const userService = new UserService()
        if (userService.isLoggedIn()) {
            this.getCredit()
            this.getLimitPlayer()
        }

        this.findOrderAbility()
    },

    methods: {
        isPageIntro() {
            if (typeof this.$route === 'undefined') {
                return false
            }

            const url = new URL(window.location.href)
            const type = url.searchParams.get('type')

            return this.$route.name && this.$route.name == 'my-quiz'
        },

        onClearIntroLocal() {
            this.showDropdown = false
            window.localStorage.removeItem('intro-step')

            if (this.$route.name && this.$route.name == 'my-quiz') {
                this.$emit('clear-intro')
            }

            if (this.$route.name && this.$route.name == 'start-quiz') {
                if (!this.isPlayTogether) {
                    //Remove step join as master/player
                    this.stepTour4 = this.stepTour4.filter(
                        step => step.element !== '#join-as-master' && step.element !== '#join-as-player'
                    )
                }

                setSetting('tour4', 0)
                startIntroMasterStart(this.stepTour4)
            }
        },

        handleOpenModal() {
            if (this.isLoggedIn()) {
                this.showDropdown = true
                return
            }

            this.showDropdown = false

            if (this.$route.name.includes('skoler')) {
                this.$store.commit('setShowFeideLogin', true)
                return
            }

            this.$emit('open-auth-popup')
        },

        handleOpenNewsletter() {
            this.showDropdown = false
            this.$store.commit('setShowNewsletterModal', true)
        },

        logout() {
            const isSchoolUser = ['teacher', 'student', 'teacher_plus', 'student_plus'].includes(this.userRole())

            if (currentUser().provider === 'feide') {
                this.$store.commit('setShowLogoutPopup', true)
                return
            }

            const userService = new UserService()
            userService.removeToken()

            this.$emit('click-logout')

            setTimeout(() => {
                if (currentUser().provider === 'feide') {
                    window.location.href = nuxtUrl('/skoler')
                    return
                }

                if (isSchoolUser) {
                    window.location.href = nuxtUrl('/school')
                    return
                }

                window.location.href = nuxtUrl('/')
            }, 800)
        },

        isLoggedIn() {
            const userService = new UserService()
            return userService.isLoggedIn()
        },

        userRole() {
            const userService = new UserService()
            const role = userService.getUser().role || ''

            return role
        },

        isBackendUser() {
            return ['super_admin', 'admin', 'contributor', 'premium_user'].indexOf(this.userRole()) > -1
        },

        validateToken() {
            const userService = new UserService()

            userService
                .validateToken()
                .then(() => {})
                .catch(err => {
                    if (err && err.message === 'Network Error') {
                        return
                    }

                    userService.removeToken()
                })
        },

        clickYourQuiz() {
            this.$emit('click-your-quiz-link')
        },

        clickNewQuiz() {
            this.$emit('click-new-quiz')
        },

        clickEditProfile() {
            this.$emit('click-edit-profile')
        },

        clickOrder() {
            this.$emit('click-order')
        },

        clickSubscribePlan() {
            this.$emit('click-subscribe-plan')
        },

        clickBuyCredit() {
            this.$emit('click-buy-credit')
        },

        clickSubpage(page) {
            this.$emit('click-subpage', page)
        },

        onDropdownToggleHandler() {
            if (this.embed) {
                this.$emit('click-with-embed')
            } else {
                this.showDropdown = !this.showDropdown
            }
        },

        getSubPageMenu() {
            const request = new Request()

            request
                .get(appConfig.api.fetchMenu)
                .then(res => {
                    this.$store.commit('setSubPageMenu', res.data.data)

                    this.subMenu = this.subPageMenu.filter(menu => {
                        if (
                            this.getIsSchoolRoles() &&
                            ['term-conditions', 'terms-conditions-no', 'privacy-policy'].includes(menu.slug)
                        ) {
                            return false
                        }

                        if (this.getIsStudentRoles() && ['qa', 'question-types'].includes(menu.slug)) {
                            return false
                        }

                        return true
                    })
                })
                .catch(() => {})
        },

        getCredit: function () {
            if (!this.$store) {
                const userService = new UserService()
                const token = userService.getToken()
                const request = new Request({
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                const url = appConfig.api.getCredit.replace('__id__', userService.getUser().id)

                request
                    .get(url)
                    .then(res => {
                        this.credit = res.data.data ? res.data.data.credit : 0
                        this.credit = parseFloat(this.credit.toFixed(2))
                    })
                    .catch(() => {})

                return
            }

            if (this.isLoggedIn()) {
                this.$store.dispatch('getCredit')
            }
        },

        togglePageSlidePopup: function (slug) {
            this.showDropdown = false
            this.$store.commit('setPageSliderPopup', { show: true, slug })
        },

        changeLanguage: function () {
            this.showDropdown = false
            this.$emit('change-language')
        },

        findOrderAbility() {
            if (!this.isLoggedIn()) {
                return
            }
            const userService = new UserService()
            const token = userService.getToken()

            const request = new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            request.get(appConfig.api.findOrderAbility).then(res => {
                this.orderAbility = res.data.data

                if (this.$store) {
                    this.$store.commit('setOrderAbility', res.data.data)
                }
            })
        },

        showPremium() {
            if (this.isBackendUser()) {
                return true
            }

            if (
                (this.orderAbility.is_24hrs_access || this.orderAbility.is_has_subscribed) &&
                !this.getIsSchoolRoles()
            ) {
                return true
            }

            return false
        },

        stylePremium() {
            if (this.isBackendUser()) {
                return 'backend-user'
            }

            if (this.orderAbility.has_subscribed) {
                return 'premium'
            }

            if (this.orderAbility.is_24hrs_access) {
                return 'oneday-premium'
            }
        },

        styleSchoolRole() {
            return this.userRole().includes('plus') ? 'plus' : 'basic'
        },

        toggleShowSchoolModal() {
            this.showDropdown = false
            this.showSwitchSchoolModal = true

            this.$nextTick(() => {
                this.$refs.switchSchool.openModal()
            })
        },

        async getLimitPlayer() {
            const userService = new UserService()
            const token = userService.getToken()

            const request = new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            let limit = await request.get(appConfig.api.limitPlayer)
            if (limit.status === 200) {
                this.limitPlayer = limit.data.data.limit
            }
        }
    }
}
</script>

<style lang="scss">
@mixin smallheight() {
    @media screen and (max-height: 700px) {
        @content;
    }
}

.dropdown-backdrop {
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0);
    width: 100%;
    height: 100%;
    z-index: 99;
}

.right-menu {
    column-gap: 1rem;
    font-size: 14px;
}

.right-menu,
.right-menu-relative {
    .bar-icon {
        font-size: 1.5em;
        color: #fff;

        @media (max-width: 575px) {
            margin-top: 0.24rem;
            font-size: 2em;
        }
    }

    .text-link {
        color: var(--ui-primary-color);
    }

    // .user-info-block {
    //     @include smallheight {
    //         margin-bottom: 0.3rem;
    //     }
    // }

    .user-icon {
        font-size: 1.5rem;
        color: var(--ui-primary-color);
        // @include smallheight {
        //     font-size: .9rem;
        // }
    }

    .username-text {
        font-size: 1.125em;
        color: var(--ui-primary-color);

        // @include smallheight {
        //     margin-bottom: .3rem;
        // }
    }

    .credit-text {
        font-size: 1em;
        color: var(--ui-primary-color);
    }

    .menu-dropdown {
        right: 0px;
        position: absolute;
        background-color: var(--background-primary-color);
        border: 1px solid var(--ui-primary-color);
        width: 320px;
        padding: 0.5rem;
        border-radius: 3px;
        z-index: 99;
        transition: all 0.2s ease;
        top: 20px;
        visibility: hidden;
        opacity: 0;

        // .scrollable {
        //     max-height: 500px;
        //     overflow-y: auto;
        // }

        @media (max-width: 575px) {
            width: calc(100vw - 30px);
            max-height: 70vh;
            overflow-y: scroll;
        }

        &.show {
            visibility: visible;
            opacity: 1 !important;
            top: 43px;
        }

        ul {
            padding: 0;
            margin: 0;

            li {
                --item-space: 0.8rem 0.42rem;

                list-style: none;
                padding: 0;
                line-height: 1;
                border-bottom: 1px solid var(--ui-primary-color);

                &.more-space {
                    padding: var(--item-space);

                    // @include smallheight {
                    //     padding: .1rem .2rem;;
                    // }
                }

                &:last-child {
                    border-bottom: 0;
                }

                span,
                a,
                i {
                    text-shadow: none;
                }

                i {
                    text-align: center;
                    width: 25px;
                    margin-right: 0.5rem;
                }

                a {
                    font-size: 1.2em;
                    color: var(--ui-primary-color);
                    display: flex;
                    text-decoration: none;
                    padding: var(--item-space);

                    &:not(.logout-link) {
                        &:hover {
                            background-color: var(--background-primary-color-dark);
                        }
                    }

                    // @include smallheight {
                    //     padding: .65rem .2rem;
                    //     font-size: .9rem;
                    // }
                }
            }
        }

        .divider {
            width: 100%;
            border-bottom: 2px dashed var(--ui-primary-color);
            margin: 0.5rem 0;
        }

        .sub-menu-box {
            @media screen and (min-width: 768px) {
                max-height: 200px;
                overflow-y: auto;
            }
        }

        .logout-link {
            font-size: 14px;
            padding: 0;
            align-items: center;
            flex-direction: column;

            > span {
                font-size: 1em;

                // @include smallheight {
                //     font-size: .9rem;
                // }
            }
            > i {
                margin-right: 0;
                font-size: 1.1rem;
                padding-left: 7px;

                // @include smallheight {
                //     font-size: 1.1rem;
                // }
            }
        }

        #school-box {
            border: 1px solid var(--ui-primary-color);
            border-radius: 3px;
            color: var(--ui-primary-color);
            padding: 0.5rem;
            line-height: 1.2;
        }
    }
    #text-premium {
        margin-top: 0.5rem;
        display: inline-block;
        color: #fff;
        padding: 2px 7px;
        border-radius: 16px;
        font-size: 0.9em;

        &.premium {
            background-color: gold;
        }

        &.oneday-premium {
            background-color: red;
        }

        &.backend-user {
            background-color: green;
        }
    }

    #school-role {
        margin-top: 0.5rem;
        display: inline-block;
        color: #fff;
        padding: 2px 7px;
        border-radius: 16px;
        font-size: 0.8rem;

        &.plus {
            background-color: gold;
        }

        &.basic {
            background-color: green;
        }

        .icon-user {
            width: 10px;
            font-size: 10px;
            padding: 0;
            margin: 0;
        }
    }
}
</style>
